import { render } from "./ConcurrentNodeConfig.vue?vue&type=template&id=967b2850&scoped=true&ts=true"
import script from "./ConcurrentNodeConfig.vue?vue&type=script&lang=ts"
export * from "./ConcurrentNodeConfig.vue?vue&type=script&lang=ts"

import "./ConcurrentNodeConfig.vue?vue&type=style&index=0&id=967b2850&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-967b2850"]])

export default __exports__